/* ============================================================
   jh-header.js — Custom Header für Inner Sparkle
   Phase 1: Drawer-Toggle, Akkordeon, Sticky-Behavior, USP-Rotation
   ============================================================ */

(function () {
  'use strict';

  // Deploy-Marker: in der Browser-Konsole `window.__jhHeaderVersion` eingeben.
  // Kommt der String zurück, ist GENAU diese Datei aktiv (kein alter Cache).
  window.__jhHeaderVersion = 'jh-2026-10-16-lupe-fix';

  /* ===== Drawer Toggle ===== */

  function initDrawer() {
    var toggleBtns = document.querySelectorAll('[data-jh-drawer-toggle]');
    var closeBtns = document.querySelectorAll('[data-jh-drawer-close]');
    var drawer = document.querySelector('[data-jh-drawer]');

    if (!drawer) return;

    // Drawer und Overlay als direkte body-Kinder verschieben damit kein
    // Parent-Stacking-Context (z.B. transformed Header-Section) im Weg liegt.
    var jhOverlayInit = drawer.querySelector('overlay-element');
    if (jhOverlayInit && jhOverlayInit.parentNode !== document.body) {
      document.body.appendChild(jhOverlayInit);
    }
    if (drawer.parentNode !== document.body) {
      document.body.appendChild(drawer);
    }

    // Concepts Hamburger-Button(s) abfangen und an unseren Drawer hängen
    // Wir suchen Concepts .menu-drawer-button (rendert via header-icons snippet)
    var conceptHamburgers = document.querySelectorAll('.header-section .menu-drawer-button');
    conceptHamburgers.forEach(function (btn) {
      // aria-controls von MenuDrawer auf JhDrawer umbiegen
      btn.setAttribute('aria-controls', drawer.id);
      // als Toggle markieren damit der Listener unten greift
      btn.setAttribute('data-jh-drawer-toggle', '');
    });

    // Re-query nach dem Hook
    toggleBtns = document.querySelectorAll('[data-jh-drawer-toggle]');

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.removeAttribute('inert');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('jh-drawer-open');
      if (drawer.classList.contains('jh-drawer--slideup-sheet')) {
        document.body.classList.add('jh-drawer-sheet-open');
      }

      // Concept-Pattern: overlay-element via aria-expanded triggern
      var jhOverlay = document.querySelector('overlay-element[aria-controls="' + drawer.id + '"]');
      if (jhOverlay) {
        jhOverlay.setAttribute('aria-expanded', 'true');
        if (!jhOverlay.__jhBound) {
          jhOverlay.addEventListener('click', function () {
            if (drawer.classList.contains('is-open')) closeDrawer();
          });
          jhOverlay.__jhBound = true;
        }
      }

      toggleBtns.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'true');
      });

      // Fokus auf Close-Button für Accessibility
      setTimeout(function () {
        var closeBtn = drawer.querySelector('[data-jh-drawer-close]');
        if (closeBtn) closeBtn.focus();
      }, 100);
    }

    function closeDrawer() {
      // Closing-Klasse triggert die Schließ-Animation
      drawer.classList.add('is-closing');
      drawer.classList.remove('is-open');
      drawer.setAttribute('inert', '');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('jh-drawer-open');

      // Concept-Pattern: overlay-element via aria-expanded zurücksetzen
      var jhOverlayClose = document.querySelector('overlay-element[aria-controls="' + drawer.id + '"]');
      if (jhOverlayClose) {
        jhOverlayClose.setAttribute('aria-expanded', 'false');
      }

      // Closing-Klasse nach Animation wieder entfernen
      window.setTimeout(function () {
        drawer.classList.remove('is-closing');
        document.body.classList.remove('jh-drawer-sheet-open');
      }, 280);

      // Reset Such-State: Input leeren, Panel verstecken, Drawer-Body-Klasse entfernen
      var drawerSearchInputs = drawer.querySelectorAll('[data-jh-search] [data-jh-search-input]');
      drawerSearchInputs.forEach(function (inp) {
        inp.value = '';
        // dispatch input event so JS state resets
        inp.dispatchEvent(new Event('input', { bubbles: true }));
      });
      var drawerBody = drawer.querySelector('.jh-drawer__body');
      if (drawerBody) drawerBody.classList.remove('has-active-search');

      toggleBtns.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    }

    toggleBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (drawer.classList.contains('is-open')) {
          closeDrawer();
        } else {
          openDrawer();
        }
      }, true); // capture phase, damit wir VOR Concepts Listener feuern
    });

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        closeDrawer();
      });
    });

    // ESC schließt Drawer
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    // Swipe-to-close (Touch, nur wenn aktiviert)
    if (drawer.hasAttribute('data-jh-swipe-close')) {
      var touchStartX = 0;
      var touchStartY = 0;
      var touchStartTime = 0;
      var touchTracking = false;

      var animMode = drawer.getAttribute('data-jh-anim') || 'slide_left';
      var isVertical = (animMode === 'slide_up');
      var edgeZone = 30; // px vom inneren Drawer-Rand → immer Swipe-Close

      drawer.addEventListener('touchstart', function (e) {
        if (!drawer.classList.contains('is-open')) return;
        if (e.touches.length !== 1) return;

        var startX = e.touches[0].clientX;
        var startY = e.touches[0].clientY;
        var rect = drawer.getBoundingClientRect();

        // Edge-Zone: rechter Rand bei slide_left, oberer Rand bei slide_up
        var isEdgeStart = false;
        if (isVertical) {
          var distFromTop = startY - rect.top;
          isEdgeStart = distFromTop <= edgeZone;
        } else {
          var distFromRightEdge = rect.right - startX;
          isEdgeStart = distFromRightEdge <= edgeZone;
        }

        if (isVertical && !isEdgeStart) {
          // Slide-Up: nur tracken wenn Drawer-Body ganz oben gescrollt ist
          var scrollableEl = drawer.querySelector('.jh-drawer__body, .jh-drawer__inner');
          if (scrollableEl && scrollableEl.scrollTop > 0) {
            return;
          }
        }

        if (!isEdgeStart) {
          // In scroll-baren Elementen kein Drawer-Swipe (außer am Edge)
          var t = e.target;
          while (t && t !== drawer) {
            if (t.classList && (
                t.classList.contains('jh-drawer__carousel-track') ||
                t.classList.contains('jh-drawer__carousel') ||
                t.classList.contains('jh-search__tabs') ||
                t.classList.contains('swiper') ||
                t.classList.contains('swiper-wrapper') ||
                t.hasAttribute('data-jh-no-swipe')
              )) {
              return;
            }
            t = t.parentElement;
          }
        }

        touchStartX = startX;
        touchStartY = startY;
        touchStartTime = Date.now();
        touchTracking = true;
      }, { passive: true });

      drawer.addEventListener('touchmove', function (e) {
        if (!touchTracking) return;
        var dx = e.touches[0].clientX - touchStartX;
        var dy = e.touches[0].clientY - touchStartY;

        if (isVertical) {
          // Slide-Up: Wisch primär horizontal → abbrechen (lass es scrollen)
          if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) {
            touchTracking = false;
            return;
          }
          // Nur nach unten interessant (dy positiv)
          if (dy > 0) {
            var translateY = Math.min(dy, drawer.offsetHeight);
            drawer.style.transform = 'translateY(' + translateY + 'px)';
            drawer.style.transition = 'none';
          }
        } else {
          // Slide-Left: Wisch primär vertikal → abbrechen
          if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 10) {
            touchTracking = false;
            return;
          }
          if (dx < 0) {
            var translateX = Math.max(dx, -drawer.offsetWidth);
            drawer.style.transform = 'translateX(' + translateX + 'px)';
            drawer.style.transition = 'none';
          }
        }
      }, { passive: true });

      drawer.addEventListener('touchend', function (e) {
        if (!touchTracking) return;
        touchTracking = false;
        var dx = e.changedTouches[0].clientX - touchStartX;
        var dy = e.changedTouches[0].clientY - touchStartY;
        var elapsed = Date.now() - touchStartTime;
        drawer.style.transform = '';
        drawer.style.transition = '';

        if (isVertical) {
          var height = drawer.offsetHeight;
          // Höherer Threshold (45%) damit kleine Bewegungen nicht versehentlich schließen
          if (dy > height * 0.45 || (elapsed < 250 && dy > 80)) {
            closeDrawer();
          }
        } else {
          var width = drawer.offsetWidth;
          if (dx < -width * 0.35 || (elapsed < 300 && dx < -50)) {
            closeDrawer();
          }
        }
      }, { passive: true });

      drawer.addEventListener('touchcancel', function () {
        touchTracking = false;
        drawer.style.transform = '';
        drawer.style.transition = '';
      });
    }

    // Beim Wechsel auf Desktop (≥990px) Drawer & Standalone-Search schließen
    var mediaQuery = window.matchMedia('(min-width: 990px)');
    function handleBreakpointChange(e) {
      if (e.matches) {
        if (drawer.classList.contains('is-open')) {
          closeDrawer();
        }
        // Auch ein eventuell offenes Standalone-Search-Overlay schließen
        var openStandalone = document.querySelector('.jh-search--standalone.is-open');
        if (openStandalone) {
          openStandalone.classList.remove('is-open');
          openStandalone.setAttribute('inert', '');
          openStandalone.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('jh-search-open');
        }
      }
    }
    // Safari < 14 fallback
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handleBreakpointChange);
    } else if (mediaQuery.addListener) {
      mediaQuery.addListener(handleBreakpointChange);
    }
  }

  /* ===== Akkordeon ===== */

  function initAccordion() {
    var toggleBtns = document.querySelectorAll('[data-jh-accordion-toggle]');

    toggleBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var controlsId = btn.getAttribute('aria-controls');
        var content = document.getElementById(controlsId);

        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');

        if (content) {
          if (expanded) {
            content.setAttribute('hidden', '');
          } else {
            content.removeAttribute('hidden');
          }
        }
      });
    });
  }

  /* ============================================================
     TRANSPARENTER HEADER ÜBER DEM HERO
     ============================================================
     Wichtig: Das <header>-Element traegt weder .jh-header noch data-sticky — die
     Sticky-Logik kommt vom Theme selbst (is="sticky-header"). Diese Funktion haengt
     sich deshalb an data-jh-transparent und laeuft unabhaengig von der
     Sticky-Einstellung. (Vorher steckte sie in initStickyHeader(), das wegen des
     nicht existierenden Selektors sofort abbrach — dadurch fehlten sowohl das
     Hochziehen des Hero als auch .is-scrolled: oben war nur die Seitenfarbe mit
     weisser, unsichtbarer Schrift zu sehen, und beim Scrollen schob sich das
     Hero-Bild unter den Header. Genau der "umgekehrte" Effekt.)

     Drei Dinge, die CSS allein nicht kann:
       1. Header-Hoehe messen und den ersten sichtbaren Abschnitt per negativem
          Abstand darunter ziehen — erst dann liegt der Header ueber dem Hero.
       2. .is-scrolled setzen/entfernen, damit der Hintergrund beim Scrollen einblendet.
       3. Eine helle Logo-Kopie ueber das normale Logo legen; die Umblendung macht CSS. */

  /* ===== Logo-Kopie auf das Original ausrichten =====
     Selbst wenn beide Bilder exakt denselben Kasten bekommen, kann das Motiv im
     hellen Logo anders in der Datei sitzen (anderer Rand links/rechts) — dann steht
     der Schriftzug sichtbar versetzt. Hier wird darum von beiden Dateien gemessen,
     wo das Motiv wirklich anfaengt (erste nicht durchsichtige Bildspalte/-zeile),
     und die Kopie per transform daraufgelegt.

     Faellt irgendetwas aus (kein Alphakanal, CORS verbietet das Auslesen), passiert
     einfach nichts — dann bleibt es bei der Ausrichtung ueber den Kasten. */

  var jhInkCache = {};
  var jhSwitchTimer = 0;
  var jhSwitchTimeout = 0;

  /* ===== Icons mit eigenem Shadow-DOM =====
     Das Konto-Icon kommt nicht vom Theme, sondern von Shopify als eigenes Element
     <shopify-account>. Dessen Innenleben steckt in einem Shadow-Root, an den kein
     CSS von aussen herankommt — dort steht Shopifys eigene Regel
     "transition: color .5s cubic-bezier(.6,0,.4,1) .1s". Beim Umschalten sprang
     deshalb alles sofort um, nur dieses eine Icon blendete nach.

     Loesung: in jeden offenen Shadow-Root im Header eine kleine Regel einhaengen,
     die auf dieselbe Klasse hoert wie der Header. Waehrend des Umschaltens traegt
     der Host .jh-switching, :host(.jh-switching) greift, danach laeuft alles wieder
     normal — Hover-Effekte des Bauteils bleiben also erhalten. */

  var jhShadowHosts = null;

  function jhFindShadowHosts(header) {
    if (jhShadowHosts && jhShadowHosts.length) return jhShadowHosts;
    var found = [];
    header.querySelectorAll('*').forEach(function (n) {
      if (n.shadowRoot) found.push(n);       // nur offene Shadow-Roots
    });
    jhShadowHosts = found;
    return found;
  }

  function jhPatchShadowHosts(header) {
    jhFindShadowHosts(header).forEach(function (host) {
      var sr = host.shadowRoot;
      if (!sr || sr.querySelector('style[data-jh-switch]')) return;
      var st = document.createElement('style');
      st.setAttribute('data-jh-switch', '');
      st.textContent =
        ':host(.jh-switching), :host(.jh-switching) *,' +
        ':host(.jh-switching) *::before, :host(.jh-switching) *::after' +
        '{ transition: none !important; }';
      sr.appendChild(st);
    });
  }

  function jhInkBox(src) {
    if (jhInkCache[src]) return jhInkCache[src];
    var p = new Promise(function (resolve) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onerror = function () { resolve(null); };
      img.onload = function () {
        try {
          var W = 400;
          var H = Math.max(1, Math.round(400 * img.naturalHeight / img.naturalWidth));
          var c = document.createElement('canvas');
          c.width = W; c.height = H;
          var ctx = c.getContext('2d');
          ctx.drawImage(img, 0, 0, W, H);
          var d = ctx.getImageData(0, 0, W, H).data;
          var minX = W, maxX = -1, minY = H, maxY = -1;
          for (var y = 0; y < H; y++) {
            for (var x = 0; x < W; x++) {
              if (d[(y * W + x) * 4 + 3] > 16) {
                if (x < minX) minX = x;
                if (x > maxX) maxX = x;
                if (y < minY) minY = y;
                if (y > maxY) maxY = y;
              }
            }
          }
          if (maxX < 0) { resolve(null); return; }   // voellig leeres Bild
          resolve({
            l: minX / W, w: (maxX - minX + 1) / W,
            t: minY / H, h: (maxY - minY + 1) / H
          });
        } catch (e) {
          resolve(null);                              // Auslesen nicht erlaubt
        }
      };
      img.src = src;
    });
    jhInkCache[src] = p;
    return p;
  }

  /* Wo landet das Bild innerhalb seines Kastens? Haengt an object-fit. */
  function jhDrawnBox(fit, natW, natH, W, H) {
    if (fit !== 'contain' && fit !== 'scale-down') return { ox: 0, oy: 0, dw: W, dh: H };
    if (!natW || !natH) return { ox: 0, oy: 0, dw: W, dh: H };
    var r = natW / natH, dw = W, dh = W / r;
    if (dh > H) { dh = H; dw = H * r; }
    return { ox: (W - dw) / 2, oy: (H - dh) / 2, dw: dw, dh: dh };
  }

  function alignArtwork(base, alt) {
    var bSrc = base.currentSrc || base.src;
    var aSrc = alt.currentSrc || alt.src;
    if (!bSrc || !aSrc) return;
    Promise.all([jhInkBox(bSrc), jhInkBox(aSrc)]).then(function (res) {
      var a = res[0], b = res[1];
      if (!a || !b || !b.w || !b.h) return;
      var W = base.offsetWidth, H = base.offsetHeight;
      if (!W || !H) return;

      var bBox = jhDrawnBox(getComputedStyle(base).objectFit, base.naturalWidth, base.naturalHeight, W, H);
      var aBox = jhDrawnBox('contain', alt.naturalWidth, alt.naturalHeight, W, H);

      var baseX = bBox.ox + a.l * bBox.dw, baseW = a.w * bBox.dw;
      var altX  = aBox.ox + b.l * aBox.dw, altW  = b.w * aBox.dw;
      var baseY = bBox.oy + a.t * bBox.dh, altY  = aBox.oy + b.t * aBox.dh;
      if (!altW) return;

      var s = baseW / altW;
      if (!isFinite(s) || s <= 0 || s > 4) return;
      var dx = baseX - s * altX;
      var dy = baseY - s * altY;
      if (!isFinite(dx) || !isFinite(dy)) return;

      // Unter einem halben Pixel lohnt der Eingriff nicht.
      if (Math.abs(dx) < 0.5 && Math.abs(dy) < 0.5 && Math.abs(s - 1) < 0.005) {
        alt.style.removeProperty('transform');
        return;
      }
      alt.style.setProperty('transform-origin', '0 0', 'important');
      alt.style.setProperty(
        'transform',
        'translate(' + dx.toFixed(2) + 'px, ' + dy.toFixed(2) + 'px) scale(' + s.toFixed(4) + ')',
        'important'
      );
    });
  }

  function initTransparentHeader() {
    var header = document.querySelector('header[data-jh-transparent], .jh-header[data-jh-transparent]');
    if (!header) return;

    var root = document.documentElement;
    var hero = null;

    /* Aus- bzw. nicht eingeschaltet: alle Spuren entfernen (wichtig im Theme-Editor,
       wenn die Einstellung waehrend der Sitzung umgestellt wird). */
    if (header.dataset.jhTransparent !== '1') {
      root.classList.remove('jh-transparent-active');
      root.classList.remove('jh-hero-resolved');
      header.classList.remove('is-scrolled', 'jh-has-transparent-logo');
      var stale = document.querySelector('.jh-hero--under-header');
      if (stale) {
        stale.classList.remove('jh-hero--under-header');
        stale.style.removeProperty('margin-top');
      }
      return;
    }

    /* --- 1. Hero hochziehen --- */

    function findHero() {
      var main = document.getElementById('MainContent') || document.querySelector('main');
      if (!main) return null;
      var kids = main.children;
      for (var i = 0; i < kids.length; i++) {
        // Erster Abschnitt mit echter Hoehe — leere/ausgeblendete Sections ueberspringen.
        if (kids[i].offsetHeight > 0) return kids[i];
      }
      return null;
    }

    function measure() {
      // Aufrunden, nie abrunden: ein abgerundeter Wert laesst den Hero einen
      // Bruchteil eines Pixels zu tief sitzen — auf iOS wird daraus eine sichtbare
      // helle Linie. Den zusaetzlichen Ueberstand gibt --jh-header-overlap im CSS.
      var h = Math.ceil(header.getBoundingClientRect().height);
      if (!h) return;
      root.style.setProperty('--jh-header-h', h + 'px');
      // Exakte Hoehe fuer den naechsten Seitenaufbau merken — das kurze Skript im
      // Markup setzt sie dann sofort, noch bevor der Header gezeichnet wird.
      try { sessionStorage.setItem('jhHeaderH', String(h)); } catch (e) {}

      var found = findHero();
      if (!found) return;
      // Alte Markierungen entfernen (Abschnitt kann sich im Theme-Editor aendern).
      document.querySelectorAll('.jh-hero--under-header').forEach(function (el) {
        if (el === found) return;
        el.classList.remove('jh-hero--under-header');
        el.style.removeProperty('margin-top');
      });
      hero = found;
      hero.classList.add('jh-hero--under-header');
      // Der Abstand selbst kommt aus dem CSS (inkl. --jh-header-overlap), damit es
      // dafuer nur eine Quelle gibt. Ein frueher gesetzter inline-Wert muss weg.
      hero.style.removeProperty('margin-top');
      // Ab hier steht der Ziel-Abschnitt fest; die :first-child-Notregel im CSS
      // schaltet sich damit ab.
      root.classList.add('jh-transparent-active');
      root.classList.add('jh-hero-resolved');
      placeLogos();
    }

    measure();
    // init() kann im Theme-Editor mehrfach laufen -> Listener nur einmal binden.
    var alreadyBound = header.dataset.jhTpBound === '1';
    header.dataset.jhTpBound = '1';
    if (!alreadyBound) {
      window.addEventListener('resize', measure);
      window.addEventListener('load', measure);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    }

    /* --- 2. Scroll-Zustand --- */

    /* Beim Umschalten kurz alle Uebergaenge im Header stilllegen, damit Schrift,
       Icons und Logo die neue Farbe sofort haben. Ohne das laufen die Uebergaenge
       der einzelnen Links und Icons aus dem Theme weiter — transition vererbt sich
       nicht, eine Regel auf dem Header allein erreicht sie nicht. Nach zwei Bildern
       ist der neue Zustand gezeichnet und die Klasse kann wieder weg. */
    var scrolledNow = null;

    function syncScrolled() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var want = y > 10;
      if (want === scrolledNow) return;
      scrolledNow = want;

      jhPatchShadowHosts(header);
      switching(true);
      if (want) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');

      // Nach zwei gezeichneten Bildern wieder freigeben. Der Zeitgeber daneben ist
      // die Absicherung: in einem Hintergrund-Tab laeuft requestAnimationFrame
      // nicht, die Klasse duerfte dort aber nicht haengen bleiben.
      if (jhSwitchTimer) cancelAnimationFrame(jhSwitchTimer);
      if (jhSwitchTimeout) clearTimeout(jhSwitchTimeout);
      jhSwitchTimer = requestAnimationFrame(function () {
        jhSwitchTimer = requestAnimationFrame(function () {
          jhSwitchTimer = 0;
          switching(false);
        });
      });
      jhSwitchTimeout = setTimeout(function () { switching(false); }, 200);
    }

    function switching(on) {
      if (on) header.classList.add('jh-switching');
      else header.classList.remove('jh-switching');
      jhFindShadowHosts(header).forEach(function (host) {
        if (on) host.classList.add('jh-switching');
        else host.classList.remove('jh-switching');
      });
    }
    syncScrolled();

    if (!alreadyBound) {
      var tickingTp = false;
      window.addEventListener('scroll', function () {
        if (tickingTp) return;
        tickingTp = true;
        window.requestAnimationFrame(function () {
          syncScrolled();
          tickingTp = false;
        });
      }, { passive: true });
    }

    /* --- 3. Helles Logo ---
       Die helle Kopie liegt absolut ueber dem normalen Logo. Mit inset: 0 spannte sie
       ueber den gesamten Innenbereich des Links — hat der Link Innenabstand, sass das
       helle Logo dadurch ein paar Pixel weiter links als das normale. Darum wird ihr
       Kasten hier exakt auf den Kasten des normalen Logos gesetzt; maßgeblich ist
       immer das normale Logo. */

    function placeLogos() {
      header.querySelectorAll('.jh-logo--transparent').forEach(function (alt) {
        // Die Kopie steht immer direkt hinter ihrem Original (auch bei mehreren
        // Logos fuer Mobil und Desktop) — darum das Geschwisterelement nehmen.
        var base = alt.previousElementSibling;
        if (!base || base.tagName !== 'IMG' || !base.offsetWidth) return;
        alt.style.setProperty('left', base.offsetLeft + 'px', 'important');
        alt.style.setProperty('top', base.offsetTop + 'px', 'important');
        alt.style.setProperty('width', base.offsetWidth + 'px', 'important');
        alt.style.setProperty('height', base.offsetHeight + 'px', 'important');
        alignArtwork(base, alt);
      });
    }

    var altSrc = header.dataset.jhTransparentLogo;
    if (!altSrc) return;              // kein helles Logo hinterlegt -> normales Logo bleibt stehen
    header.classList.add('jh-has-transparent-logo');
    header.querySelectorAll('.header__logo-link img.logo').forEach(function (img) {
      if (img.classList.contains('jh-logo--transparent')) return;
      // Marker am Bild selbst, nicht am Elternelement: Mobil- und Desktop-Logo
      // haengen im selben Link, sonst bekaeme nur das erste eine helle Kopie —
      // und das jeweils andere waere im transparenten Zustand unsichtbar.
      if (img.dataset.jhLogoAlt === '1') return;
      img.dataset.jhLogoAlt = '1';
      var alt = img.cloneNode(false);
      alt.className = img.className + ' jh-logo--transparent';
      alt.removeAttribute('srcset');
      alt.removeAttribute('sizes');
      alt.removeAttribute('data-jh-logo-alt');
      alt.src = altSrc;
      alt.setAttribute('aria-hidden', 'true');
      alt.setAttribute('alt', '');
      img.parentNode.insertBefore(alt, img.nextSibling);
    });
    placeLogos();
    if (!alreadyBound) {
      window.addEventListener('resize', placeLogos);
      window.addEventListener('load', placeLogos);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(placeLogos);
    }
  }

  /* ============================================================
     OFFENES MEGA-MENÜ BEIM SCROLLEN SCHLIESSEN
     ============================================================
     Der Sticky-Header faehrt beim Scrollen per transform nach oben. Ein offenes
     Mega-Menue haengt im Header und wandert mit — es stand dann ueber der
     Ankuendigungsleiste (vor allem in Safari). Frueher hing das an eigenen
     Sticky-Klassen, die es im DOM nicht gibt; jetzt haengt es nur am Scrollweg und
     funktioniert unabhaengig davon, wie das Theme seinen Sticky-Header schaltet. */

  var megaScrollBound = false;

  function initCloseMegaOnScroll() {
    if (megaScrollBound) return;      // init() laeuft im Theme-Editor mehrfach
    megaScrollBound = true;

    var MEGA = 'details[is="details-mega"], details.mega-menu';
    var openedAt = null;

    // 'toggle' blubbert nicht -> in der Capture-Phase mithoeren.
    document.addEventListener('toggle', function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches(MEGA)) return;
      openedAt = t.open ? (window.pageYOffset || document.documentElement.scrollTop || 0) : null;
    }, true);

    window.addEventListener('scroll', function () {
      if (openedAt === null) return;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (Math.abs(y - openedAt) < 40) return;
      document.querySelectorAll('details[is="details-mega"][open], details.mega-menu[open]').forEach(function (d) {
        d.open = false;
      });
      openedAt = null;
    }, { passive: true });
  }

  /* ===== Sticky-Header Behavior (eigene Variante, nur falls .jh-header gesetzt ist) ===== */

  function initStickyHeader() {
    var header = document.querySelector('.jh-header[data-sticky="on-scroll-up"]');
    if (!header) return;

    var lastScroll = 0;
    var threshold = 80;

    function closeOpenMegaMenus() {
      document.querySelectorAll('details[is="details-mega"][open], details.mega-menu[open]').forEach(function (d) {
        d.open = false;
      });
    }

    function onScroll() {
      var current = window.pageYOffset || document.documentElement.scrollTop;

      // Scrolled state
      if (current > 8) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }

      // Hide on scroll down, show on scroll up
      if (current > threshold) {
        if (current > lastScroll) {
          // Der Header versteckt sich per transform nach oben. Ein offenes Mega-Menü
          // haengt im Header und wuerde mitwandern — es landete dann ueber der
          // Ankuendigungsleiste. Darum vorher schliessen.
          closeOpenMegaMenus();
          header.classList.add('is-hidden');
        } else {
          header.classList.remove('is-hidden');
        }
      } else {
        header.classList.remove('is-hidden');
      }

      lastScroll = current;
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          onScroll();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    // Also handle always-sticky
    var alwaysSticky = document.querySelector('.jh-header[data-sticky="always"]');
    if (alwaysSticky) {
      window.addEventListener('scroll', function () {
        if (window.pageYOffset > 8) {
          alwaysSticky.classList.add('is-scrolled');
        } else {
          alwaysSticky.classList.remove('is-scrolled');
        }
      }, { passive: true });
    }
  }

  /* ===== USP-Bar Auto-Rotate ===== */

  function initUspRotation() {
    var uspBars = document.querySelectorAll('.jh-usp-bar[data-jh-usp-mode="rotate"]');

    uspBars.forEach(function (bar) {
      var items = bar.querySelectorAll('.jh-usp-bar__item');
      if (items.length <= 1) return;

      var interval = parseInt(bar.getAttribute('data-jh-usp-interval'), 10) || 4000;
      var index = 0;

      setInterval(function () {
        items[index].removeAttribute('data-active');
        index = (index + 1) % items.length;
        items[index].setAttribute('data-active', '');
      }, interval);
    });
  }

  /* ===== Cart-Count Live Update (optional, listens to cart events) ===== */

  function initCartCount() {
    var cartCounts = document.querySelectorAll('[data-jh-cart-count]');
    if (!cartCounts.length) return;

    // Listen to Shopify cart update events if theme dispatches them
    document.addEventListener('cart:updated', function (e) {
      var newCount = (e.detail && e.detail.cart && e.detail.cart.item_count) || 0;
      cartCounts.forEach(function (el) {
        el.textContent = newCount;
        if (newCount === 0) {
          el.classList.add('is-empty');
        } else {
          el.classList.remove('is-empty');
        }
      });
    });

    // Fallback: poll cart.js after add-to-cart fetches
    document.addEventListener('click', function (e) {
      var target = e.target.closest('[name="add"], [data-cart-submit]');
      if (!target) return;
      setTimeout(function () {
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            cartCounts.forEach(function (el) {
              el.textContent = cart.item_count;
              if (cart.item_count === 0) {
                el.classList.add('is-empty');
              } else {
                el.classList.remove('is-empty');
              }
            });
          })
          .catch(function () { /* silent */ });
      }, 800);
    });
  }

  /* ===== Predictive Search ===== */

  function initPredictiveSearch() {
    var searches = document.querySelectorAll('[data-jh-search]');
    if (!searches.length) return;

    searches.forEach(function (root) {
      var input = root.querySelector('[data-jh-search-input]');
      var clearBtn = root.querySelector('[data-jh-search-clear]');
      var panel = root.querySelector('[data-jh-search-panel]');
      var loadingState = root.querySelector('[data-jh-search-loading]');
      var noResultsState = root.querySelector('[data-jh-search-no-results]');
      var tabs = root.querySelectorAll('[data-jh-search-tab]');
      var tabPanels = root.querySelectorAll('[data-jh-search-tab-content]');
      var showAllBtn = root.querySelector('[data-jh-search-show-all]');
      var form = root.querySelector('[data-jh-search-form]');
      var mode = root.dataset.mode;
      var resultLimit = parseInt(root.dataset.resultLimit, 10) || 6;
      var showAllLabel = root.dataset.showAllLabel || 'Alle Ergebnisse anzeigen';
      var showProductPrice = root.dataset.showProductPrice === 'true';
      var showProductImage = root.dataset.showProductImage === 'true';

      var currentQuery = '';
      var debounceTimer = null;

      if (!input) return;

      // Triggers (only standalone has external triggers)
      if (mode === 'standalone') {
        var standaloneTriggers = document.querySelectorAll('[data-jh-search-trigger="standalone"][aria-controls="' + root.id + '"]');
        standaloneTriggers.forEach(function (trigger) {
          trigger.addEventListener('click', function (e) {
            e.preventDefault();
            openStandalone();
          });
        });
      }


      function openStandalone() {
        root.classList.add('is-open');
        root.removeAttribute('inert');
        root.setAttribute('aria-hidden', 'false');
        document.body.classList.add('jh-search-open');
        setTimeout(function () { input.focus(); }, 100);
      }

      function closeStandalone() {
        root.classList.remove('is-open');
        root.setAttribute('inert', '');
        root.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('jh-search-open');
        input.value = '';
        hidePanel();
      }

      function showPanel() {
        if (panel) panel.hidden = false;
        root.classList.add('jh-search--active');
        if (mode === 'drawer') {
          var drawerBody = root.closest('.jh-drawer__body');
          if (drawerBody) drawerBody.classList.add('has-active-search');
        }
      }

      function hidePanel() {
        if (panel) panel.hidden = true;
        root.classList.remove('jh-search--active');
        tabPanels.forEach(function (p) { p.innerHTML = ''; });
        if (showAllBtn) showAllBtn.style.display = 'none';
        if (loadingState) loadingState.style.display = 'none';
        if (noResultsState) noResultsState.style.display = 'none';
        if (mode === 'drawer') {
          var drawerBody = root.closest('.jh-drawer__body');
          if (drawerBody) drawerBody.classList.remove('has-active-search');
        }
      }

      // X-Button: clear text → if already empty, close (standalone) or just blur (drawer)
      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          if (input.value.length > 0) {
            input.value = '';
            clearBtn.style.display = 'none';
            input.focus();
            hidePanel();
          } else {
            if (mode === 'standalone') {
              closeStandalone();
            } else {
              input.blur();
              hidePanel();
            }
          }
        });
      }

      // ESC
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (mode === 'standalone' && root.classList.contains('is-open')) {
          if (input.value.length > 0) {
            input.value = '';
            clearBtn.style.display = 'none';
            hidePanel();
          } else {
            closeStandalone();
          }
        } else if (mode === 'drawer' && root.classList.contains('jh-search--active')) {
          if (input.value.length > 0) {
            input.value = '';
            clearBtn.style.display = 'none';
            hidePanel();
          } else {
            input.blur();
            hidePanel();
          }
        }
      });

      // Form submit
      if (form) {
        form.addEventListener('submit', function (e) {
          if (!input.value.trim()) {
            e.preventDefault();
          }
        });
      }

      // Show-all button
      if (showAllBtn) {
        showAllBtn.addEventListener('click', function () {
          if (form && input.value.trim()) {
            form.submit();
          }
        });
      }

      // Tab switching
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var tabName = tab.dataset.jhSearchTab;
          tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');
          tabPanels.forEach(function (panel) {
            panel.hidden = panel.dataset.jhSearchTabContent !== tabName;
          });
        });
      });

      // Input listener
      input.addEventListener('input', function () {
        var q = input.value.trim();
        if (clearBtn) clearBtn.style.display = q.length > 0 ? 'flex' : 'none';

        clearTimeout(debounceTimer);

        if (q.length === 0) {
          hidePanel();
          return;
        }

        if (q.length < 2) {
          showPanel();
          if (loadingState) loadingState.style.display = 'block';
          if (noResultsState) noResultsState.style.display = 'none';
          tabPanels.forEach(function (p) { p.hidden = true; });
          return;
        }

        showPanel();
        if (loadingState) loadingState.style.display = 'block';
        if (noResultsState) noResultsState.style.display = 'none';

        debounceTimer = setTimeout(function () {
          fetchPredictiveResults(q);
        }, 220);
      });

      // Focus → show panel if there's already a query
      input.addEventListener('focus', function () {
        if (input.value.trim().length >= 2) {
          showPanel();
        }
      });

      function fetchPredictiveResults(q) {
        currentQuery = q;

        var resources = [];
        tabPanels.forEach(function (p) {
          resources.push(p.dataset.jhSearchTabContent);
        });
        if (!resources.length) return;

        // Map plural tab keys to Shopify's singular API types
        var typeMap = {
          'products': 'product',
          'articles': 'article',
          'collections': 'collection',
          'pages': 'page',
          'queries': 'query'
        };

        // One request per type so the limit applies per-type independently.
        var requests = resources.map(function (pluralType) {
          var apiType = typeMap[pluralType] || pluralType;
          var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
                    '&resources[type]=' + apiType +
                    '&resources[limit]=' + resultLimit;
          return fetch(url)
            .then(function (r) { return r.json(); })
            .then(function (data) {
              var bucket = data.resources && data.resources.results ? data.resources.results : {};
              // Shopify uses plural keys in the response (products, articles, ...)
              return { pluralType: pluralType, items: bucket[pluralType] || [] };
            })
            .catch(function () {
              return { pluralType: pluralType, items: [] };
            });
        });

        Promise.all(requests).then(function (chunks) {
          if (q !== currentQuery) return;
          var merged = {};
          chunks.forEach(function (c) { merged[c.pluralType] = c.items; });
          renderResults(merged);
        });
      }

      function renderResults(results) {
        if (loadingState) loadingState.style.display = 'none';

        var anyResults = false;

        tabPanels.forEach(function (tp) {
          var type = tp.dataset.jhSearchTabContent;
          var items = results[type] || [];
          if (items.length > 0) anyResults = true;

          tp.innerHTML = '';

          if (items.length === 0) {
            var emptyMsg = document.createElement('li');
            emptyMsg.className = 'jh-search__tab-empty';
            emptyMsg.textContent = 'Keine Treffer in dieser Kategorie.';
            tp.appendChild(emptyMsg);
            return;
          }

          items.forEach(function (item) {
            tp.appendChild(buildResultItem(type, item));
          });
        });

        // Re-show active tab's panel
        var activeTab = root.querySelector('[data-jh-search-tab].is-active');
        if (activeTab) {
          var tabName = activeTab.dataset.jhSearchTab;
          tabPanels.forEach(function (p) {
            p.hidden = p.dataset.jhSearchTabContent !== tabName;
          });
        } else {
          // No tabs (only 1 panel)
          tabPanels.forEach(function (p) { p.hidden = false; });
        }

        if (anyResults) {
          if (noResultsState) noResultsState.style.display = 'none';
          if (showAllBtn) {
            showAllBtn.style.display = '';
            var labelSpan = showAllBtn.querySelector('[data-jh-search-show-all-label]');
            if (labelSpan) labelSpan.textContent = showAllLabel;
          }
        } else {
          if (noResultsState) noResultsState.style.display = 'block';
          if (showAllBtn) showAllBtn.style.display = 'none';
        }
      }

      function buildResultItem(type, item) {
        var li = document.createElement('li');
        li.className = 'jh-search__item jh-search__item--' + type;

        var a = document.createElement('a');
        a.href = item.url || '#';
        a.className = 'jh-search__item-link';

        if (type === 'products') {
          if (showProductImage && item.featured_image && item.featured_image.url) {
            var imgWrap = document.createElement('div');
            imgWrap.className = 'jh-search__item-image';
            var img = document.createElement('img');
            img.src = item.featured_image.url.replace(/(\.[^.]+)$/, '_120x120$1');
            img.alt = item.featured_image.alt || item.title || '';
            img.loading = 'lazy';
            img.decoding = 'async';
            img.width = 60;
            img.height = 60;
            imgWrap.appendChild(img);
            a.appendChild(imgWrap);
          }

          var info = document.createElement('div');
          info.className = 'jh-search__item-info';

          var title = document.createElement('span');
          title.className = 'jh-search__item-title';
          title.textContent = item.title;
          info.appendChild(title);

          if (showProductPrice && item.price) {
            var priceWrap = document.createElement('div');
            priceWrap.className = 'jh-search__item-price';

            var price = document.createElement('span');
            price.className = 'jh-search__item-price-current';
            price.textContent = formatPrice(item.price);
            priceWrap.appendChild(price);

            if (item.compare_at_price && parseFloat(item.compare_at_price) > parseFloat(item.price)) {
              var compare = document.createElement('span');
              compare.className = 'jh-search__item-price-compare';
              compare.textContent = formatPrice(item.compare_at_price);
              priceWrap.appendChild(compare);
            }

            info.appendChild(priceWrap);
          }

          a.appendChild(info);
        } else {
          // Articles, collections, pages: image (if present) + title
          var articleImage = item.image || item.featured_image;
          if (articleImage && (articleImage.url || typeof articleImage === 'string')) {
            var imgWrap2 = document.createElement('div');
            imgWrap2.className = 'jh-search__item-image';
            var img2 = document.createElement('img');
            var imgUrl = articleImage.url || articleImage;
            img2.src = imgUrl.replace(/(\.[^.]+)(\?.*)?$/, '_120x120$1$2');
            img2.alt = (articleImage.alt) || item.title || '';
            img2.loading = 'lazy';
            img2.decoding = 'async';
            img2.width = 60;
            img2.height = 60;
            imgWrap2.appendChild(img2);
            a.appendChild(imgWrap2);
          }

          var info2 = document.createElement('div');
          info2.className = 'jh-search__item-info';
          var title2 = document.createElement('span');
          title2.className = 'jh-search__item-title';
          title2.textContent = item.title || item.text || '';
          info2.appendChild(title2);
          a.appendChild(info2);
        }

        li.appendChild(a);
        return li;
      }

      function formatPrice(priceStr) {
        var num = parseFloat(priceStr);
        if (isNaN(num)) return priceStr;
        if (num > 1000 && num % 1 === 0) num = num / 100;
        return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(num);
      }
    });
  }

  /* ===== Init ===== */

  function initLangDropdown() {
    var wraps = document.querySelectorAll('[data-jh-lang-dropdown]');
    wraps.forEach(function (wrap) {
      var toggle = wrap.querySelector('[data-jh-lang-toggle]');
      var menu = wrap.querySelector('[data-jh-lang-menu]');
      if (!toggle || !menu) return;

      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (isOpen) {
          menu.setAttribute('hidden', '');
        } else {
          menu.removeAttribute('hidden');
        }
      });

      document.addEventListener('click', function (e) {
        if (!wrap.contains(e.target)) {
          toggle.setAttribute('aria-expanded', 'false');
          menu.setAttribute('hidden', '');
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          toggle.setAttribute('aria-expanded', 'false');
          menu.setAttribute('hidden', '');
        }
      });
    });
  }

  function init() {
    initDrawer();
    initAccordion();
    initStickyHeader();
    initTransparentHeader();
    initCloseMegaOnScroll();
    initUspRotation();
    initCartCount();
    initPredictiveSearch();
    initLangDropdown();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify section reload (Theme Editor).
  // Der Header traegt .jh-header nicht — deshalb ueber data-jh-mega-speed bzw.
  // data-jh-transparent erkennen, sonst lief das hier nie.
  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target || !e.target.querySelector) return;
    if (e.target.querySelector('[data-jh-mega-speed], [data-jh-transparent], .jh-header')) {
      init();
    }
  });
})();

/* ============================================================
   MEGA-MENU INSTANT HOVER (kein Concept-Delay)
   ============================================================ */
(function () {
  function initInstantHover() {
    var megas = document.querySelectorAll('details[is="details-mega"]');
    megas.forEach(function (d) {
      if (d.__jhInstantBound) return;
      d.__jhInstantBound = true;

      // Schließen anderer offener Mega-Menus beim Wechsel
      function closeOthers() {
        document.querySelectorAll('details[is="details-mega"][open]').forEach(function (other) {
          if (other !== d) other.removeAttribute('open');
        });
      }

      d.addEventListener('mouseenter', function () {
        closeOthers();
        d.setAttribute('open', '');
        // Concept's eigene visibility-Klasse direkt entfernen
        var container = d.querySelector('.mega-menu__container');
        if (container) container.classList.remove('invisible');
        // Im offenen Zustand neu ausrichten — hier stimmen die Messwerte.
        requestAnimationFrame(function () { alignMegaMenu(d); });
      });

      d.addEventListener('mouseleave', function () {
        d.removeAttribute('open');
        var container = d.querySelector('.mega-menu__container');
        if (container) container.classList.add('invisible');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInstantHover);
  } else {
    initInstantHover();
  }
  document.addEventListener('shopify:section:load', initInstantHover);

  /* ===== Promo-Button Color-Force =====
     Concept's Header-CSS überschreibt Link-Backgrounds mit !important.
     CSS-Spezifität reicht nicht; JS pushed die Farben als inline-style mit
     !important direkt aufs Element — höchste mögliche Priorität.
     Hover-Farben werden bei mouseenter/leave gewechselt wenn gesetzt. */
  function applyPromoColors() {
    document.querySelectorAll('.jh-header__promo-btn').forEach(function (btn) {
      if (btn.dataset.jhPromoBound === '1') return;
      btn.dataset.jhPromoBound = '1';

      var bg = (btn.style.getPropertyValue('--jh-promo-bg') || '').trim() || '#7B4D32';
      var color = (btn.style.getPropertyValue('--jh-promo-color') || '').trim() || '#FBF7F6';
      var bgHover = (btn.style.getPropertyValue('--jh-promo-bg-hover') || '').trim();
      var colorHover = (btn.style.getPropertyValue('--jh-promo-color-hover') || '').trim();

      function setNormal() {
        btn.style.setProperty('background-color', bg, 'important');
        btn.style.setProperty('background-image', 'none', 'important');
        btn.style.setProperty('color', color, 'important');
        // Filter brightness als Default-Hover wenn keine expliziten Farben
        btn.style.removeProperty('filter');
      }

      function setHover() {
        if (bgHover) {
          btn.style.setProperty('background-color', bgHover, 'important');
        }
        if (colorHover) {
          btn.style.setProperty('color', colorHover, 'important');
        }
        if (bgHover || colorHover) {
          // Explizite Hover-Farben überschreiben filter brightness
          btn.style.setProperty('filter', 'none', 'important');
        }
      }

      setNormal();
      btn.addEventListener('mouseenter', setHover);
      btn.addEventListener('mouseleave', setNormal);
      btn.addEventListener('focus', setHover);
      btn.addEventListener('blur', setNormal);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyPromoColors);
  } else {
    applyPromoColors();
  }
  document.addEventListener('shopify:section:load', applyPromoColors);

  /* ===== Mega-Menu Animation Speed Force =====
     Concept setzt transition-duration mit höherer Spezifität — CSS reicht nicht.
     JS pushed transition-duration direkt aufs Element als inline-style mit !important.
     Greift auf Concept's Slide-Down (transform translateY) + meine Underline (background-size). */
  function applyMegaSpeed() {
    var header = document.querySelector('[data-jh-mega-speed]');
    if (!header) return;
    var megaNum = parseInt(header.dataset.jhMegaSpeed, 10);
    if (isNaN(megaNum)) megaNum = 180;
    var underlineNum = parseInt(header.dataset.jhUnderlineSpeed, 10);
    if (isNaN(underlineNum)) underlineNum = megaNum;
    var megaSpeed = megaNum + 'ms';
    var underlineSpeed = underlineNum + 'ms';
    var megaMotion = header.dataset.jhMegaMotion || 'fade';

    document.querySelectorAll('details[is="details-mega"]').forEach(function (d) {
      var container = d.querySelector('.mega-menu__container');
      var summary = d.querySelector('summary');

      // Mega-Menu: opacity + transform.
      // Im Modus "fade" bleibt jede Bewegung weg — Concept schiebt den Inhalt sonst
      // per translateY von oben ein, was ueber die Panel-Oberkante in den Header
      // ragt (in Safari deutlich sichtbar).
      if (container) {
        if (megaMotion === 'fade') {
          container.style.setProperty('transform', 'none', 'important');
          container.style.setProperty('transition', 'opacity ' + megaSpeed + ' ease 0s', 'important');
        } else {
          container.style.removeProperty('transform');
          container.style.setProperty(
            'transition',
            'opacity ' + megaSpeed + ' ease 0s, transform ' + megaSpeed + ' ease 0s',
            'important'
          );
        }
      }
      // Underline: background-size (eigene Speed)
      if (summary) {
        summary.style.setProperty(
          'transition',
          'background-size ' + underlineSpeed + ' ease 0s',
          'important'
        );
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyMegaSpeed);
  } else {
    applyMegaSpeed();
  }
  document.addEventListener('shopify:section:load', applyMegaSpeed);

  /* Richtet EIN Mega-Menu aus: top an die Header-Unterkante, und im Content-Modus
     die linke Kante an den linken Header-Rand — dieselbe Linie wie SHOP. */
  function alignMegaMenu(details) {
    var header = document.querySelector('header[data-section-id], .shopify-section-header header, header.header');
    if (!header) return;
    var headerRect = header.getBoundingClientRect();

    var alignHeader = document.querySelector('header[data-jh-mega-align]');
    var alignMode = alignHeader ? alignHeader.dataset.jhMegaAlign : 'content';

    var cs = getComputedStyle(header);
    var padL = parseFloat(cs.paddingLeft) || 0;
    var padR = parseFloat(cs.paddingRight) || 0;
    var targetLeft = headerRect.left + padL;
    var targetWidth = headerRect.width - padL - padR;

    var menu = details.querySelector('.mega-menu');
    if (!menu) return;
    var detailsRect = details.getBoundingClientRect();

    var topOffset = headerRect.bottom - detailsRect.top;
    if (topOffset > 0) {
      menu.style.setProperty('top', topOffset + 'px', 'important');
    }

    if (alignMode !== 'trigger' && targetWidth > 200) {
      var menuLeftNow = menu.getBoundingClientRect().left;
      var curLeftInline = parseFloat(menu.style.left) || 0;
      var newLeft = curLeftInline + (targetLeft - menuLeftNow);
      menu.style.setProperty('left', newLeft + 'px', 'important');
      menu.style.setProperty('right', 'auto', 'important');
      menu.style.setProperty('width', targetWidth + 'px', 'important');
      menu.style.setProperty('max-width', 'none', 'important');
    } else {
      menu.style.removeProperty('left');
      menu.style.removeProperty('right');
      menu.style.removeProperty('width');
      menu.style.removeProperty('max-width');
    }
  }

  /* ===== Mega-Menu Position (alle) =====
     Laeuft bei Load/Resize. Die praezise Ausrichtung passiert zusaetzlich beim
     Oeffnen (mouseenter), weil nur dann die Menue-Position verlaesslich messbar ist. */
  function setMegaTop() {
    document.querySelectorAll('details[is="details-mega"]').forEach(function (details) {
      alignMegaMenu(details);
    });
  }

  /* ===== Mega-Menu Höhen angleichen =====
     Alle Menüs bekommen die Höhe des hoechsten als min-height.

     Kernproblem: ein geschlossenes <details> blendet seinen Inhalt aus, die Hoehe
     ist also 0. Ein simples Messen liefert deshalb nur fuer das gerade offene Menue
     einen Wert — alle anderen zaehlen als 0 und nichts wird angeglichen.
     Loesung: geschlossene Menues zum Messen kurz unsichtbar ausklappen
     (display:block + visibility:hidden + position:absolute), messen, zuruecksetzen.

     Ausserdem bewusst min-height statt height + overflow: beim Laden sind Webfont
     und Bilder noch nicht fertig, jede Messung ist erst mal zu klein. Mit min-height
     waechst der Wert spaeter nach, statt Inhalt abzuschneiden. */
  var jhEqualizeObserver = null;

  function jhClearEqualize() {
    document.querySelectorAll('details[is="details-mega"] .jh-mega').forEach(function (w) {
      w.style.removeProperty('height');
      w.style.removeProperty('min-height');
      w.style.removeProperty('overflow');
    });
  }

  /* Misst die Menues und setzt die groesste Hoehe als min-height auf alle.

     Kein Zwangsoeffnen: ein geschlossenes <details> hat in Chrome per
     content-visibility keine messbare Hoehe, und es kurz aufzuklappen ist keine
     Option — das toggle-Event feuert asynchron, Concept faehrt danach seine
     Oeffnen-Logik hoch und die Menues blitzen auf.

     Stattdessen wird jedes Menue gemessen, wenn es ohnehin geoeffnet wird. Der
     hoechste je gemessene Wert gilt fuer alle. Die Werte liegen in der
     sessionStorage, ab dem zweiten Seitenaufruf stimmen die Hoehen also sofort.

     min-height statt height: misst der Browser beim Laden zu klein (Webfont, Bilder
     noch nicht fertig), waechst der Wert spaeter nach statt abzuschneiden. */
  var jhHeights = {};
  var jhHeightsKey = 'jhMegaHeights';

  function jhLoadHeights() {
    try {
      var raw = sessionStorage.getItem(jhHeightsKey);
      var data = raw ? JSON.parse(raw) : null;
      // Hoehen haengen von der Fensterbreite ab — nur denselben Breitenstand nutzen
      if (data && data.w === window.innerWidth) jhHeights = data.h || {};
    } catch (e) {}
  }

  function jhSaveHeights() {
    try {
      sessionStorage.setItem(jhHeightsKey, JSON.stringify({ w: window.innerWidth, h: jhHeights }));
    } catch (e) {}
  }

  function jhApplyMax() {
    var wrappers = document.querySelectorAll('details[is="details-mega"] .jh-mega');
    if (wrappers.length < 2) return;

    // Offene Menues messen — nur die liefern echte Werte
    wrappers.forEach(function (w, i) {
      var d = w.closest('details');
      if (!d || !d.open) return;
      var prev = w.style.getPropertyValue('min-height');
      w.style.removeProperty('min-height');
      var h = w.getBoundingClientRect().height;
      if (prev) w.style.setProperty('min-height', prev, 'important');
      if (h > 0 && h > (jhHeights[i] || 0)) {
        jhHeights[i] = h;
        jhSaveHeights();
      }
    });

    var max = 0;
    Object.keys(jhHeights).forEach(function (k) {
      if (jhHeights[k] > max) max = jhHeights[k];
    });
    if (max <= 0) return;

    wrappers.forEach(function (w) {
      w.style.setProperty('min-height', max + 'px', 'important');
    });
  }

  function equalizeMegaHeights() {
    var header = document.querySelector('header[data-jh-equalize-heights]');
    if (!header || header.dataset.jhEqualizeHeights !== '1') {
      jhClearEqualize();
      return;
    }

    jhApplyMax();

    if (jhEqualizeObserver || !window.ResizeObserver) return;
    jhEqualizeObserver = new ResizeObserver(function () {
      if (jhEqualizeObserver._pending) return;
      jhEqualizeObserver._pending = true;
      requestAnimationFrame(function () {
        jhEqualizeObserver._pending = false;
        jhApplyMax();
      });
    });
    document.querySelectorAll('details[is="details-mega"] .jh-mega').forEach(function (w) {
      jhEqualizeObserver.observe(w);
    });
  }

  /* Nachladende Bilder und Webfonts veraendern die Hoehen — danach neu messen. */
  function jhBindEqualizeTriggers() {
    jhLoadHeights();
    document.querySelectorAll('details[is="details-mega"] .jh-mega img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', equalizeMegaHeights, { once: true });
    });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(equalizeMegaHeights);
    }
    document.querySelectorAll('details[is="details-mega"]').forEach(function (d) {
      if (d.dataset.jhEqBound === '1') return;
      d.dataset.jhEqBound = '1';
      d.addEventListener('toggle', function () {
        if (d.open) requestAnimationFrame(equalizeMegaHeights);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setMegaTop();
      equalizeMegaHeights();
      jhBindEqualizeTriggers();
    });
  } else {
    setMegaTop();
    equalizeMegaHeights();
    jhBindEqualizeTriggers();
  }
  window.addEventListener('load', function () {
    equalizeMegaHeights();
    jhBindEqualizeTriggers();
  });
  window.addEventListener('resize', function () {
    setMegaTop();
    jhHeights = {};
    equalizeMegaHeights();
  });
  document.addEventListener('shopify:section:load', function () {
    setMegaTop();
    equalizeMegaHeights();
  });

  // Bei jedem Öffnen re-positionieren UND Speed re-pushen
  // (Concept's JS überschreibt die inline transition sonst beim Toggle)
  document.querySelectorAll('details[is="details-mega"]').forEach(function (details) {
    // mouseenter/focus: BEVOR Concept öffnet — transition ist rechtzeitig gesetzt
    details.addEventListener('mouseenter', applyMegaSpeed);
    details.addEventListener('focusin', applyMegaSpeed);

    // toggle: nach dem Öffnen sicherheitshalber alles nochmal setzen
    details.addEventListener('toggle', function () {
      if (details.open) {
        applyMegaSpeed();
        requestAnimationFrame(function () {
          setMegaTop();
          applyMegaSpeed();
        });
        setTimeout(function () {
          setMegaTop();
          applyMegaSpeed();
        }, 50);
      }
    });

    // MutationObserver: wenn Concept die inline style der .mega-menu__container ändert,
    // pushen wir unsere Werte sofort wieder rein
    var container = details.querySelector('.mega-menu__container');
    if (container && window.MutationObserver) {
      var obs = new MutationObserver(function () {
        if (container.dataset.jhSpeedGuard === '1') return;
        container.dataset.jhSpeedGuard = '1';
        requestAnimationFrame(function () {
          applyMegaSpeed();
          container.dataset.jhSpeedGuard = '0';
        });
      });
      obs.observe(container, { attributes: true, attributeFilter: ['style'] });
    }
  });

  /* ============================================================
     Eigenständiges Inline-Suchfeld (Desktop) — unabhängig von der
     Drawer-/Standalone-Suche. Eigenes Dropdown mit Leerzustand +
     Live-Produktvorschlägen über die Predictive-API.
     ============================================================ */
  function jhInitInlineSearch() {
    var roots = document.querySelectorAll('[data-jh-inline-search]');
    roots.forEach(function (root) {
      var input = root.querySelector('[data-jh-inline-input]');
      var dropdown = root.querySelector('[data-jh-inline-dropdown]');
      var empty = root.querySelector('[data-jh-inline-empty]');
      var results = root.querySelector('[data-jh-inline-results]');
      var products = root.querySelector('[data-jh-inline-products]');
      var loading = root.querySelector('[data-jh-inline-loading]');
      var noresults = root.querySelector('[data-jh-inline-noresults]');
      var allLink = root.querySelector('[data-jh-inline-all]');
      var clearBtn = root.querySelector('[data-jh-inline-clear]');
      var form = root.querySelector('.jh-inline-search__form');
      if (!input || !dropdown) return;
      if (root.dataset.jhInlineBound === '1') return;   // schon gebunden (Editor-Re-Render)
      root.dataset.jhInlineBound = '1';

      // Animations-Variante (icononly): Dropdown IN das Formular hängen. Das Feld ist
      // absolut an der Lupe verankert, seine rechte Kante sitzt exakt auf der Lupe ->
      // das Dropdown (CSS: right:0; top:100%) öffnet dadurch IMMER bündig unter dem Feld,
      // statt an einem weit rechts liegenden Vorfahren (bisher: "zu weit rechts"/inkonstant).
      // Das Dropdown ist bis zum Öffnen hidden -> das Umhängen ist unsichtbar.
      if (root.classList.contains('jh-inline-search--icononly') && form && !form.contains(dropdown)) {
        form.appendChild(dropdown);
      }

      var debounce = null;
      var currentQuery = '';

      function openDropdown() {
        dropdown.hidden = false;
        root.classList.add('is-open');
      }
      function closeDropdown() {
        dropdown.hidden = true;
        root.classList.remove('is-open');
      }
      function showEmpty() {
        if (empty) empty.hidden = false;
        if (results) results.hidden = true;
      }
      function showResults() {
        if (empty) empty.hidden = true;
        if (results) results.hidden = false;
      }

      var resultTypes = (root.dataset.resultTypes || 'product').split(',');
      var resultLimit = parseInt(root.dataset.resultLimit, 10) || 6;

      function fetchResults(q) {
        currentQuery = q;
        if (loading) loading.hidden = false;
        if (noresults) noresults.hidden = true;

        // Eine Anfrage PRO Typ — sonst verteilt Shopify das globale Limit ungleich
        // und ein Typ geht leer aus. (Gleiche Logik wie die grosse Drawer-Suche.)
        var requests = resultTypes.map(function (t) {
          var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
                    '&resources[type]=' + t +
                    '&resources[limit]=' + resultLimit +
                    '&resources[options][unavailable_products]=last';
          return fetch(url)
            .then(function (r) { return r.json(); })
            .then(function (data) {
              var res = (data.resources && data.resources.results) || {};
              var key = t === 'product' ? 'products' : (t === 'collection' ? 'collections' : (t === 'article' ? 'articles' : 'pages'));
              return { type: t, items: res[key] || [] };
            })
            .catch(function () { return { type: t, items: [] }; });
        });

        Promise.all(requests).then(function (chunks) {
          if (q !== currentQuery) return;
          var merged = [];
          // Reihenfolge wie konfiguriert
          resultTypes.forEach(function (t) {
            var chunk = chunks.filter(function (c) { return c.type === t; })[0];
            if (!chunk) return;
            chunk.items.forEach(function (item) {
              item._jhType = (t === 'article' && isRecipe(item)) ? 'recipe' : t;
              merged.push(item);
            });
          });
          renderResults(merged, q);
        });
      }

      // Treffer GRUPPIERT statt als Mischliste: feste Reihenfolge Produkte -> Kategorien ->
      // Ratgeber -> Seiten, jede Gruppe mit Caps-Label. Blog/Seiten gedeckelt und immer
      // zuletzt — in einem Shop ist die Such-Intention fast immer "Produkt finden".
      var GROUP_ORDER  = ['product', 'recipe', 'collection', 'article', 'page'];
      var GROUP_LABELS = { product: 'Produkte', recipe: 'Rezepte', collection: 'Kategorien', article: 'Ratgeber', page: 'Seiten' };
      var GROUP_CAPS   = { recipe: 3, collection: 2, article: 3, page: 3 };

      // Rezepte = Artikel aus den eingestellten Blogs (/blogs/<handle>/...) oder mit
      // "rezept" in der URL. Sie bekommen eine eigene Gruppe direkt nach den Produkten.
      var recipeBlogs = (root.dataset.recipeBlogs || 'rezepte').split(',')
        .map(function (h) { return h.trim().toLowerCase(); }).filter(Boolean);
      function isRecipe(item) {
        var url = String(item.url || '').toLowerCase();
        for (var i = 0; i < recipeBlogs.length; i++) {
          if (url.indexOf('/blogs/' + recipeBlogs[i] + '/') !== -1) return true;
        }
        return /rezept/.test(url);
      }

      function buildRow(p, type) {
        var a = document.createElement('a');
        a.className = 'jh-inline-search__result jh-inline-search__result--' + type;
        a.href = p.url;
        var img = (p.featured_image && p.featured_image.url) || (p.image && p.image.url) || p.image || '';
        // Nur Produkte tragen einen Preis; der Typ ergibt sich aus dem Gruppen-Label.
        var meta = '';
        if (type === 'product') {
          // /search/suggest.json liefert den Preis als Text in Haupteinheit ("35.95"),
          // ältere Endpunkte als Zahl in Cent (3595). Beides sauber als "35,95 €" ausgeben.
          var amount = null;
          if (typeof p.price === 'number') amount = p.price / 100;
          else if (typeof p.price === 'string' && /^\d+(\.\d+)?$/.test(p.price.trim())) amount = parseFloat(p.price);
          if (amount !== null) {
            meta = amount.toLocaleString('de-DE', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
          } else if (p.price) {
            meta = p.price;
          }
        }
        a.innerHTML =
          '<span class="jh-inline-search__result-media">' +
            (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
          '</span>' +
          '<span class="jh-inline-search__result-text">' +
            '<span class="jh-inline-search__result-title">' + (p.title || '') + '</span>' +
            (meta ? '<span class="jh-inline-search__result-price">' + meta + '</span>' : '') +
          '</span>';
        return a;
      }

      function renderResults(items, q) {
        if (loading) loading.hidden = true;
        products.innerHTML = '';
        if (!items.length) {
          if (noresults) noresults.hidden = false;
          if (allLink) allLink.hidden = true;
          return;
        }
        if (noresults) noresults.hidden = true;
        GROUP_ORDER.forEach(function (type) {
          var group = items.filter(function (i) { return i._jhType === type; });
          if (GROUP_CAPS[type]) group = group.slice(0, GROUP_CAPS[type]);
          if (!group.length) return;
          var wrap = document.createElement('div');
          wrap.className = 'jh-inline-search__group jh-inline-search__group--' + type;
          var h = document.createElement('p');
          h.className = 'jh-inline-search__heading';
          h.textContent = GROUP_LABELS[type] || type;
          wrap.appendChild(h);
          group.forEach(function (p) { wrap.appendChild(buildRow(p, type)); });
          products.appendChild(wrap);
        });
        if (allLink) {
          allLink.hidden = false;
          allLink.href = root.querySelector('.jh-inline-search__form').getAttribute('action') + '?q=' + encodeURIComponent(q);
        }
      }

      // preview_layout = 'none': vor dem Tippen keine Vorschau zeigen (Dropdown bleibt
      // zu, bis wirklich gesucht wird). Alle anderen Layouts zeigen den Leerzustand.
      var noPreview = root.dataset.previewLayout === 'none';

      input.addEventListener('input', function () {
        var q = input.value.trim();
        if (clearBtn) clearBtn.hidden = q.length === 0;
        clearTimeout(debounce);
        if (q.length === 0) {
          // Text geleert: bei 'none' nur das Dropdown ausblenden (Feld NICHT schliessen,
          // sonst würde is-open entfernt und die Lupe zurückgleiten), sonst Leerzustand.
          if (noPreview) { dropdown.hidden = true; } else { showEmpty(); }
          return;
        }
        if (dropdown.hidden) openDropdown();   // bei 'none' erst jetzt öffnen
        showResults();
        if (loading) loading.hidden = false;
        debounce = setTimeout(function () { fetchResults(q); }, 220);
      });

      input.addEventListener('focus', function () {
        var q = input.value.trim();
        if (noPreview && q.length === 0) return;   // keine Vorschau bei Fokus, erst bei Eingabe
        openDropdown();
        if (q.length === 0) { showEmpty(); } else { showResults(); fetchResults(q); }
      });

      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          input.value = '';
          clearBtn.hidden = true;
          showEmpty();
          input.focus();
        });
      }

      document.addEventListener('click', function (e) {
        if (!root.contains(e.target)) closeDropdown();
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { closeDropdown(); input.blur(); }
      });

      // Trigger-Stil: Klick aufs eigene Form (Lupe+Wort) öffnet.
      if (root.dataset.fieldStyle === 'trigger') {
        form.addEventListener('click', function (e) {
          if (!root.classList.contains('is-open')) {
            e.preventDefault();
            root.classList.add('is-open');
            input.focus();
          }
        });
      }

    });
  }

  /* ===== Eigenständiger Handler für den Animation-Stil (icononly) =====
     Globale Listener werden GENAU EINMAL gebunden und ermitteln das aktuelle
     Feld-Element zur Laufzeit neu (document.querySelector). Dadurch überlebt der
     Handler ein Re-Rendern der Section im Theme-Editor (shopify:section:load) —
     kein Hängenbleiben am alten, entfernten Element mehr. */
  (function initIconOnlySearch() {
    if (window.__jhIconOnlyBound) return;   // globale Listener nur EINMAL binden
    window.__jhIconOnlyBound = true;
    window.__jhIconOnlyLoaded = true;

    var LUPE_SEL = '.search-drawer-button, .jh-header__icon--search';
    function currentRoot() { return document.querySelector('.jh-inline-search--icononly'); }

    /* Ist das Inline-Feld ueberhaupt in Benutzung?

       jh-header.css blendet .jh-inline-search unterhalb von 990px komplett aus
       (display:none, erst ab 990px display:block). Das Element bleibt dabei im DOM.
       Ohne diese Pruefung fing der Klick-Handler unten die Lupe trotzdem ab,
       unterdrueckte per preventDefault die Theme-Suche und "oeffnete" ein Feld, das
       gar nicht gezeichnet wird — auf schmaleren Fenstern passierte beim Klick auf
       die Lupe also ueberhaupt nichts.

       offsetParent ist null, sobald das Element oder ein Vorfahr display:none hat.
       Das Feld ist position:relative, nie fixed — der Test ist hier also eindeutig. */
    function fieldActive(root) {
      return !!root && root.offsetParent !== null;
    }

    // WICHTIG: Es gibt im Header oft mehrere .search-drawer-button (z.B. eine
    // versteckte Mobile-Variante bei 0,0). Wir nehmen NUR die tatsächlich sichtbare,
    // sonst landet das Feld an einer falschen (Bild-)Position.
    function visibleLupe() {
      var lupes = document.querySelectorAll(LUPE_SEL);
      for (var i = 0; i < lupes.length; i++) {
        var l = lupes[i];
        if (l.offsetParent === null) continue;            // nicht gerendert
        var r = l.getBoundingClientRect();
        if (r.width > 0 && r.right > 0 && r.bottom > 0) return l;
      }
      return null;
    }

    // Positioniert das Feld so, dass seine rechte Kante (dort erscheint das ×) genau auf
    // der Header-Lupe liegt. Das Feld ist ABSOLUT am 0×0-Anker (.jh-inline-search__anchor)
    // verankert, der im Header-Fluss neben der Lupe sitzt. Anker und Lupe bewegen sich
    // beim Scrollen/Sticky IMMER gemeinsam -> left/top werden nur EINMAL beim Öffnen (und
    // bei resize) gesetzt und bleiben über alle Scroll-Positionen korrekt. Dadurch kann
    // die vertikale Position zwischen Öffnen und Schließen nicht auseinanderlaufen
    // (kein Sprung), und es läuft kein Scroll-JS -> flüssig. Gibt true bei Erfolg zurück.
    function positionField(root) {
      var form = root.querySelector('.jh-inline-search__form');
      var anchor = root.querySelector('.jh-inline-search__anchor') || (form && form.parentNode);
      var lupe = visibleLupe();
      if (!form || !lupe || !anchor) return false;
      var lr = lupe.getBoundingClientRect();
      var ar = anchor.getBoundingClientRect();
      var lupeCenterX = lr.left + lr.width / 2;
      // Horizontal: Wir pinnen die RECHTE Feldkante — unabhängig von der (evtl. spät
      // gemessenen) Feldbreite. Der Versatz +11 sorgt dafür, dass die Feld-Lupe im
      // rechten Ruhezustand DECKUNGSGLEICH auf der Theme-Lupe sitzt (Lupe ist 22px,
      // rechtsbündig -> Mitte = Feldkante − 11 = Lupenmitte). Das ist entscheidend für
      // die sprung-/hängerfreie Übergabe beim Schließen. Das × (18px) sitzt dann mit
      // seiner Mitte 2px rechts der Lupenmitte, die rechte ×-Kante genau auf der
      // Lupen-Glyphe — weiterhin klar innerhalb der Lupe. HARTE GRENZE zusätzlich: die
      // Feldkante darf NIE weiter rechts als die Lupe selbst liegen (Account/Warenkorb).
      var desiredRight = lupeCenterX + 11;
      if (desiredRight > lr.right) desiredRight = lr.right;
      // 'right' ist absolut relativ zur rechten Ankerkante (Anker = 0px breit -> ar.left).
      // ar bewegt sich mit der Lupe mit -> gilt für jede Scroll-/Sticky-Position.
      form.style.setProperty('right', (ar.left - desiredRight) + 'px', 'important');
      form.style.setProperty('left', 'auto', 'important');
      // Vertikal: Feldmitte auf Lupenmitte (Anker sitzt i.d.R. exakt auf der Lupenmitte
      // -> topRel ~ 0; wir rechnen es dennoch aus, falls das Layout es je verschiebt).
      var topRel = (lr.top + lr.height / 2) - ar.top;
      form.style.setProperty('top', topRel + 'px', 'important');
      return true;
    }

    // Position aktualisieren (Laden/Resize). KEIN Ausblenden der Lupe — die echte
    // Header-Lupe bleibt IMMER sichtbar und gleitet beim Öffnen selbst.
    function reposition() {
      var root = currentRoot();
      if (!root) return;
      // Fenster unter 990px gezogen, waehrend das Feld offen war: sauber schliessen,
      // sonst bleibt jh-inline-open auf <html> stehen.
      if (!fieldActive(root)) {
        if (root.classList.contains('is-open')) closeField(root);
        return;
      }
      positionField(root);
    }

    // Sicherheitsnetz: Endzustand hart setzen, falls die Öffnen-Transition mal nicht
    // anläuft (z.B. Tab beim Klick kurz inaktiv). Auf sichtbarem Tab greift das nie ein.
    function forceOpenIfStuck(root) {
      if (!root.classList.contains('is-open')) return;
      var input = root.querySelector('.jh-inline-search__input');
      if (input && parseFloat(getComputedStyle(input).opacity) >= 0.9) return; // läuft normal
      var icon = root.querySelector('.jh-inline-search__icon');
      var close = root.querySelector('.jh-inline-search__close');
      var uline = root.querySelector('.jh-inline-search__uline');
      if (icon) { icon.style.setProperty('opacity', '1', 'important'); icon.style.setProperty('transform', 'translate(0, -50%)', 'important'); }
      if (input) input.style.setProperty('opacity', '1', 'important');
      if (close) { close.style.setProperty('opacity', '0.7', 'important'); close.style.setProperty('transform', 'translateY(-50%) rotate(0) scale(1)', 'important'); }
      if (uline) uline.style.setProperty('transform', 'scaleX(1)', 'important');
    }
    function clearForce(root) {
      ['.jh-inline-search__icon', '.jh-inline-search__input', '.jh-inline-search__close', '.jh-inline-search__uline'].forEach(function (sel) {
        var el = root.querySelector(sel);
        if (el) { el.style.removeProperty('opacity'); el.style.removeProperty('transform'); }
      });
    }

    function openField(root) {
      var form = root.querySelector('.jh-inline-search__form');
      var input = root.querySelector('input');
      if (!form) return;
      positionField(root);
      // Theme-Lupe ausblenden -> die gleich große Feld-Lupe erscheint an derselben Stelle.
      document.documentElement.classList.add('jh-inline-open');
      void form.offsetWidth;                 // Reflow: saubere Transition
      root.classList.add('is-open');         // Feld-Lupe gleitet nach links, × + Feld + Linie
      window.setTimeout(function () { forceOpenIfStuck(root); }, 500);
      // Fokus (und damit das Dropdown-Öffnen mit Kategorie-Bildern) ERST nach der
      // Gleit-Bewegung — sonst blockiert die schwere DOM-Arbeit die Animation (Ruckeln).
      if (input) setTimeout(function () { input.focus(); }, 400);
    }

    function closeField(root) {
      var dropdown = root.querySelector('[data-jh-inline-dropdown]');
      // Schweres Dropdown SOFORT vom Zeichnen nehmen — visibility (KEIN Reflow), damit
      // es die Schließ-Bewegung nicht weiter mitrendert.
      if (dropdown) dropdown.style.visibility = 'hidden';
      // Der Schließ-Start macht NUR das: Bewegung anstoßen. Nichts Schweres im selben
      // Frame -> die ersten Frames der Animation bleiben ruckelfrei.
      root.classList.remove('is-open');
      // Alles Weitere ERST nach der Bewegung (Theme-Lupe zurück, Aufräumen, Blur).
      window.clearTimeout(root.__jhCloseTimer);
      root.__jhCloseTimer = window.setTimeout(function () {
        document.documentElement.classList.remove('jh-inline-open');
        if (dropdown) { dropdown.hidden = true; dropdown.style.visibility = ''; }
        clearForce(root);
        var input = root.querySelector('input');
        if (input) { input.value = ''; input.blur(); }
      }, 360);
    }

    // 1) Klick-Handler (capture): Schließen-× und Lupe (Feld-Lupe ODER Header-Lupe) als Auslöser.
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var root = currentRoot();
      if (!root) return;   // kein Animation-Feld aktiv -> Theme-Suche normal lassen
      // Feld unterhalb 990px ausgeblendet -> Klick NICHT abfangen, damit die normale
      // Theme-Suche (Drawer/Overlay) wie gewohnt aufgeht.
      if (!fieldActive(root)) return;
      // Schließsymbol im offenen Feld?
      if (e.target.closest('[data-jh-inline-close]')) {
        e.preventDefault(); e.stopPropagation(); closeField(root); return;
      }
      // Lupe als Auslöser? Die feld-eigene Lupe liegt über der (ausgeblendeten) Header-Lupe.
      var onIcon = e.target.closest('.jh-inline-search--icononly .jh-inline-search__icon');
      var onLupe = e.target.closest(LUPE_SEL);
      if (!onIcon && !onLupe) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      if (root.classList.contains('is-open')) closeField(root);
      else openField(root);
    }, true);

    // 2) Klick außerhalb: schließen.
    document.addEventListener('click', function (e) {
      var root = currentRoot();
      if (!root || !root.classList.contains('is-open')) return;
      if (e.target.closest && (e.target.closest(LUPE_SEL) || e.target.closest('.jh-inline-search--icononly .jh-inline-search__icon'))) return;
      if (root.contains(e.target)) return;
      closeField(root);
    });

    window.addEventListener('resize', reposition);
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var root = currentRoot();
      if (root && root.classList.contains('is-open')) closeField(root);
    });

    // Beim Laden (und nach jedem Editor-Re-Render) nur die Feldposition setzen.
    // Die echte Header-Lupe bleibt sichtbar — es wird nichts aus-/eingeblendet.
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reposition);
    else reposition();
    window.addEventListener('load', reposition);
    document.addEventListener('shopify:section:load', function () {
      var root = currentRoot();
      if (root) root.classList.remove('is-open');
      document.documentElement.classList.remove('jh-inline-open'); // Theme-Lupe zurück
      requestAnimationFrame(reposition);
    });
  })();

  /* Inline-Suche initial binden UND nach jedem Editor-Re-Render neu binden.
     jhInitInlineSearch ist idempotent (data-jh-inline-bound); der icononly-Handler
     bindet global und findet das neue Element von selbst. */
  jhInitInlineSearch();
  document.addEventListener('shopify:section:load', function () {
    jhInitInlineSearch();
  });
})();